
import Vue from "vue";
import { Component } from "vue-property-decorator";

/**
 * 不可关闭的模态框
 */
@Component({
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isShow(newVal, oldVal) {
      let dialog = this.$refs.dialog as HTMLDialogElement;

      if (typeof dialog.showModal != "function") {
        return; //浏览器不支持 dialog
      }

      if (newVal) {
        dialog.showModal();
      } else {
        dialog.close();
      }
    }
  }
})
export default class BeatModal extends Vue {
  isShow: boolean = false;
  constructor() {
    super();
  }
}
